
import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import LoginStore from '@/login/store';
import { store } from '@/store';

getModule(LoginStore, store);

@Component
export default class EnrollmentComplete extends Vue {
	// eslint-disable-next-line class-methods-use-this
	created() {
		sessionStorage.clear();
	}

	redirect() {
		this.$router.push({ name: 'login' });
	}
}
